import $api from '@services/api'
import store from '@state/store'
import { success, fail } from '@/helpers/result-helper'
import { isSuccess } from '@/helpers/http-status-helpers'

export default async function() {
  store.commit('signalr/START_LOADING')

  try {
    const response = await $api.signalR.get()
    if (isSuccess(response.status)) {
      store.commit('signalr/SET_TOKEN', response.data.authKeyQS)
      store.commit(
        'signalr/SET_WEB_SOCKET_TOKEN',
        response.data.authKeyWebSockets
      )
      return success()
    }
  } catch (ex) {
    return fail(ex.response)
  } finally {
    store.commit('signalr/FINISH_LOADING')
  }
}
